import { replace } from 'lodash';
import numeral from 'numeral';

numeral.register('locale', 'es-ar', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'mm',
    billion: 'b',
    trillion: 't',
  },
  ordinal: function(number) {
    const b = number % 10;

    let suffix = '';
    switch (b) {
      case 1:
      case 3:
        suffix = 'er';
        break;

      case 2:
        suffix = 'do';
        break;

      case 7:
      case 0:
        suffix = 'mo';
        break;

      case 8:
        suffix = 'vo';
        break;

      case 9:
        suffix = 'no';
        break;

      default: // 4to, 5to y 6to
        suffix = 'to';
    }

    return suffix;
  },
  currency: {
    symbol: '$',
  },
});

numeral.locale('es-ar');

export function fCurrency(number: number | string, rounded = false): string {
  if (typeof number !== 'number') {
    number = parseFloat(number);
  }

  if (rounded) {
    return numeral(number).format(Number.isInteger(number) ? '$0' : '$0,0');
  }

  return numeral(number).format(Number.isInteger(number) ? '$0.00' : '$0,0.00');
}

export function fPercent(number: number): string {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number: number): string {
  return numeral(number).format();
}

export function fShortenNumber(number: number): string {
  return replace(numeral(number).format('0.00a'), '.00', '');
}

export function fData(number: number): string {
  return numeral(number).format('0.0 b');
}
